import { Component } from '@angular/core';
import { TabElement } from '../../core/models/tab-element';
import { TabEnum } from '../../core/enums/tab.enum';
import { RoutingService } from '../../core/services/routing.service';
import { TabService } from '../../core/services/tab.service';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
})
export class ContentComponent {
    tabs: TabElement[] = [
        {
            label: 'EINZELABFRAGE',
            title: 'Einzelabfrage',
            active: true,
            id: 'einzelabfrage',
        },
        {
            label: 'VERÄNDERUNGSMITTEILUNG',
            title: 'Veränderungsmitteilung',
            active: false,
            id: 'veraenderungsmitteilung',
        },
    ];

    constructor(private routerService: RoutingService, private tabService: TabService) {
        this.tabService.currentTab.subscribe((tab) => this.setCurrentTab(tab));
    }

    tabNavEvent(tabId: string) {
        return this.routerService.navigate(['odbs', tabId]);
    }

    setCurrentTab(activeTab: TabEnum) {
        this.tabs.forEach((tab) => {
            tab.active = tab.id === activeTab;
        });
    }
}
